<script>
  import {
    STATUS_FAIL,
    STATUS_INIT,
    STATUS_LOADING,
    STATUS_OK,
    STATUS_READY,
    TYPE_FBA,
  } from '@/variables';
  import boxComponent from '@/components/prepare_shipment/box/box';
  import createShipment from '@/components/prepare_shipment/create_shipment/create_shipment';
  import Pagination from '@/components/pagination/pagination';

  export default {
    data() {
      return {
        status: STATUS_INIT,
        STATUS_INIT,
        STATUS_LOADING,
        STATUS_OK,
        STATUS_FAIL,
        search: '',
        shipments: null,
        page: 1,
        count: null,
        itemsPerPage: 10,
      };
    },
    components: {
      createShipment_component: createShipment,
      box_component: boxComponent,
      Pagination,
    },
    created() {
      this.load();
    },
    computed: {
      user_role() {
        return this.$store.state.users.role;
      },
    },
    methods: {
      submit(context, errorAction) {
        this.$store.dispatch('shipments/submit_fba', context)
          .then(() => {
            this.load();
            this.$store.dispatch('nt_set_notification',
              { type: 'inform', message: 'Shipment was created.' });
          })
          .catch((error) => {
            this.$store.dispatch('nt_set_notification',
              { type: 'error', message: 'Shipment wasn\'t created. Please try again.' });
            errorAction(error);
          });
      },
      load() {
        this.status = STATUS_LOADING;

        const payload = {
          status: STATUS_READY,
          type: TYPE_FBA,
          page: this.page,
          search: this.search,
        };

        this.$store.dispatch('shipments/get_list', payload)
          .then((data) => {
            this.status = STATUS_OK;
            this.shipments = data.data;
            this.count = data.count;
          })
          .catch((err) => {
            console.log('catch', err);
            this.status = STATUS_FAIL;
          });
      },
      set_search(str) {
        this.search = str;
      },
    },
  };
</script>
<template src="./ready-for-shipment.pug" lang="pug"></template>
<style>
.invalid-feedback:last-child {
  position: relative;
  left: 0;
  bottom: initial;
}
</style>
